module.exports = __webpack_public_path__ + "como-font.eot?b64adf8d5bdfcbaba496a3f29496a9c7";